// eslint-disable-next-line
/// <reference path="../pug.d.ts" />
// @ts-check
'use strict';

const { removeOutsideQuotes, wrapQuotes } = require('../utils/string');

/**
 * @param {PugAst.PugNode.AnyNode} node
 * @returns {PugAst.PugNode.AnyNode}
 */
const convertImg = (node) => {
  if (node.type !== 'Tag' || node.name !== 'img' || node.attrs.some((attr) => attr.name === 'loading')) {
    return node;
  }

  const srcAttr = node.attrs.find((attr) => attr.name === 'src');
  if (!srcAttr) {
    return node;
  }

  const src = removeOutsideQuotes(srcAttr.val);
  if (!src.includes('.googleusercontent.com') && !src.includes('ds7zuo2xqlq9a.cloudfront.net')) {
    return node;
  }

  const imgAttrs = node.attrs.filter((attr) => attr.name !== 'loading');

  // NOTE: html の構造が変わって css のスタイルをあてることができなくなるため、picture タグによる webp 対応はしない
  return {
    type: 'Tag',
    name: 'img',
    block: {
      type: 'Block',
      nodes: [],
    },
    attrs: [
      ...imgAttrs,
      {
        name: 'loading',
        val: wrapQuotes('lazy'),
        mustEscape: true,
      },
    ],
    attributeBlocks: [],
  };
};

module.exports = {
  convertImg,
};
